export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const WITHDRAW_LIST = "WITHDRAW_LIST";

export const SHOW_HEADER_BALANCE = "SHOW_HEADER_BALANCE";
